<template>
    <div class="product_row">
        <base-header-img img="page_03">
            <div class="base_div product_row_header">
                <img
                    class="product_header_img"
                    src="../assets/product_img_01.png"
                />
            </div>
        </base-header-img>
        <div class="product_tabs_row">
            <img class="icon_home_3" src="../assets/home-icon_3.png" />
            <div class="base_div product_tabs">
                <div
                    :class="{
                        tab_select: selectKey === 1,
                    }"
                    class="product_tab_item"
                    @click="selectKey = 1"
                >
                    患者数字伴侣
                </div>
                <div
                    :class="{
                        tab_select: selectKey === 2,
                    }"
                    class="product_tab_item"
                    @click="selectKey = 2"
                >
                    数字医疗与照护服务平台
                </div>
            </div>
        </div>
        <div class="base_div" v-if="selectKey === 1">
            <div class="base_div_title">
                <base-title color="#10AFBC" title="患者数字伴侣"></base-title>
            </div>
            <div class="base_text">
                患者数字伴侣聚焦于数字疗法的研发以及与智能硬件厂商合作、研发与推广AI监测软件，为患者提供基于智能监测与分析调整治疗和健康管理的解决方案。
            </div>
            <div class="gray_div">
                <div
                    v-for="(item, index) in list"
                    :key="index"
                    class="product_item"
                >
                    <img class="product_item__left_img" :src="item.src" />
                    <div class="product_item_content">
                        <div class="product_item_name" v-html="item.name"></div>
                        <div
                            class="product_item_label"
                            v-html="item.label"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="base_div" v-if="selectKey === 2">
            <div class="base_div_title">
                <base-title
                    color="#10AFBC"
                    title="数字医疗与照护服务平台"
                ></base-title>
            </div>
            <div class="base_text">
                通过为医生和患提供创新技术的数字医疗与照护平台，助力医生助提升专业能力及释放个人价值，同时提升患者院外医疗服务和体验。
            </div>
            <div class="gray_div">
                <div
                    v-for="(item, index) in list2"
                    :key="index"
                    class="product_item"
                >
                    <img class="product_item__left_img" :src="item.src" />
                    <div class="product_item_content">
                        <div class="product_item_name" v-html="item.name"></div>
                        <div
                            class="product_item_label"
                            v-html="item.label"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import img01 from '../assets/product_img_02.png'
import img02 from '../assets/product_img_03.jpg'
import img03 from '../assets/product_img_04.jpg'
import img04 from '../assets/product_img_05.png'
import img05 from '../assets/product_img_06.jpg'
import img06 from '../assets/product_img_07.jpg'
import img07 from '../assets/product_img_08.jpg'
import img08 from '../assets/product_img_09.jpg'
import img09 from '../assets/product_img_10.jpg'
export default {
    name: 'product',
    data () {
        return {
            selectKey: 1,
            list: [
                { name: '智妙语：以言语康复为核心的数字疗法产品', label: '通过专业功能量表评估，自动对患者进行分类和分级；具备智能配置康复训练课程，运用语音识别技术和自适应难度调节算法，为失语症患者智能匹配课程和自动判题，使患者在没有康复师帮助情况下，可以自行进行康复训练；课程内容贴近生活真实场景，兼具实用性和科学性，实现对患者语言和言语功能的显著改善。', src: img01 },
                {
                    name: '辈宁随安智能手表血压仪:  <br/>无感连续动态监测，让您的血压控制得更平稳，远离卒中与心梗 ',
                    src: img02,
                    label: `辈宁随安智能手表血压仪，通过独家研发的技术，突破传统气泵气囊技术的局限，真正实现了精准无感连续的24小时动态血压监测。<br/>同时还为您提供专业的报告，血压异常提醒，支持血氧、心率等健康检测，远程关爱家人等功能和服务，为您和家人的健康保驾护航。<br/><img style="width:100%;height:auto;margin-top:20px" src="${img03}" />`
                }
            ],
            list2: [
                { src: img04, name: '医阵营：专科医生聚集地，拓展延伸医价值', label: '医阵营是一个专注于专病患者院外管理与医生学术交流的专业平台，致力于成为专科医生聚集地，打造医患联动的医学空间，助力拓展延伸医生的专业价值，为工作和交流提供更数字化、智能化的一站式解决方案。' },
                { src: img05, name: '心脑院外宝：连接信任的医生，让患者居家有“医靠”', label: '心脑院外宝是专为心脑血管疾病患者打造的院外管理平台，为患者及其信任的医生提供院外沟通的桥梁，为患者打造专业医疗服务，让患者居家有“医靠”。' },
                { src: img06, name: '神经系统疾病诊断：高质量神经免疫，退行性病变诊断服务', label: '采用行业领先的检测方法，全面覆盖神经系统疾病，为患者提供50项诊断服务，神免检测助手可基于患者症状，智能判断适当的检测项目，检测报告一键直达医生和患者，医患可进行线上绑定，实现更多的诊后服务。' },
                { src: img07, name: '数字学术工具：为广大临床医生提供高效的数字学术工具', label: '覆盖多领域的专科医生，打造专业的学术资源体系，包括线上学院和学术会议数字体系，有效地促进和提高临床医生在临床、科研、教学工作水平、疾病的经验交流，展示临床实践及个人学术进步成果。' },
                { src: img08, name: '专科学术交流空间：专病诊疗能力提升与学术分享', label: '用创新数字化工具，打造多重学术互动新模式，助力医生高效创作，提升医生价值。' },
                { src: img09, name: '医研社：业内领先的RWS临床科研数据平台', label: '以科室为核心，以疾病分组，提供高度产品化、模块化、SaaS化部署，以及专业化医学团队一站式、全流程研究执行服务，适用于各类临床科研场景。' }
            ]
        }
    },
    created () {
        if (this.$router.query && this.$router.query.key) {
            this.selectKey = this.$router.query.key
        }
    }
}
</script>
<style>
.product_row_header {
    text-align: left;
}
.product_header_img {
    width: 600px;
    height: auto;
}
.product_tabs_row {
    background-color: #06b1bc;
    color: #ffffff;
    font-size: 20px;
    position: relative;
}
.product_tabs {
    display: flex;
    align-items: center;
}
.product_tab_item {
    padding: 18px 26px;
    cursor: pointer;
}
.product_tabs .tab_select {
    color: #06b1bc;
    background-color: #ffffff;
}
.gray_div {
    margin-top: 40px;
    background-color: #fafafc;
    padding: 60px 32px;
}
.product_item {
    display: flex;
    margin-bottom: 80px;
}
.product_item__left_img {
    width: 350px;
    height: 203px;
    margin-right: 32px;
}
.product_item_content {
    flex: 1;
}
.product_item_name {
    color: #7d79aa;
    font-size: 24px;
    font-weight: bold;
    padding-bottom: 38px;
    border-bottom: 1px solid #dededf;
    margin-bottom: 38px;
}
.product_item_label {
    color: #3c3c3c;
    font-size: 20px;
    line-height: 38px;
    font-weight: 300;
}
.icon_home_3 {
    height: 60px;
    width: auto;
    position: absolute;
    right: 0;
    top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/view/product.vue